import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchLookup } from '../../utilities/dashboardServices'
import { toast } from 'react-toastify'

export const fetchLookUp = createAsyncThunk(
    'users/fetchLookUp', fetchLookup
)

const initialState = {
    lookUp: {},
    lookUpCPR: {
        State: [],
        insurancePlanType: [],
        fundsList: [],
        preferredLanguage: [],
        methodOfContact: [],
        patientDiagnosis: [],
        referredSource: [],
        insuranceType: [],
        insuranceCarrierName: [],
        race: [],
        methodOfPayment: [],
        treatmentSetting: [],
        physicianSpecialty: [],
        CoPayPrograms: [],
        employementStatus: [],
        gender: [],
        veteranAndHispanic: [],
        maritalStatus: [],
        applicantIs: [{
            key: 'Partner', value: 'Partner'
        }],
        emailType: [
            { key: "", value: "" },
            { key: "Home", value: "Home" },
            { key: "Work", value: "Work" },
            { key: "Other", value: "Other" },
        ],
        emailOwner: [
            { key: "", value: "" },
            { key: "Caregiver", value: "Caregiver" },
            { key: "Guardian", value: "Guardian" },
            { key: "Patient", value: "Patient" },
        ],
        phoneType: [
            { key: "Cell", value: "Cell" },
            { key: "Work", value: "Work" },
            { key: "Home", value: "Home" },
        ],
        contactSequence: [
            { key: "Primary", value: "Primary" },
        ],
        relationshipToPatient: [
            { key: "Grandparent", value: "Grandparent" },
            { key: "Other Family Member", value: "Other Family Member" },
            { key: "Parent", value: "Parent" },
            { key: "Other", value: "Other" },
        ],
        authRelationshipToPatient: [
            { key: "Friend", value: "Friend" },
            { key: "Family", value: "Family" },
            { key: "Caregiver", value: "Caregiver" },
        ],
        suffix: [
            { key: "I", value: "I" },
            { key: "II", value: "II" },
            { key: "III", value: "III" },
            { key: "IV", value: "IV" },
            { key: "Jr", value: "Jr" },
            { key: "Sr", value: "Sr" },
            { key: "V", value: "V" },
        ],
        houseHoldSize: [
            { key: "1", value: "1" },
            { key: "2", value: "2" },
            { key: "3", value: "3" },
            { key: "4", value: "4" },
            { key: "5", value: "5" },
            { key: "6", value: "6" },
            { key: "7", value: "7" },
            { key: "8", value: "8" },
            { key: "9", value: "9" },
            { key: "10", value: "10" },
        ],
        ePayment: [
            { key: "check", value: "check" },
            { key: "ePayment", value: "ePayment" },
        ], physicianAddressType: [
            { key: "Secondary", value: "Secondary" },
            { key: "Mailing", value: "Mailing" },
            { key: "Billing", value: "Billing" },
            { key: "Physical", value: "Physical" },
        ]
    },
    lookUpFAF: {
        State: [],
        insurancePlanType: [],
        fundsList: [],
        preferredLanguage: [],
        methodOfContact: [],
        patientDiagnosis: [],
        referredSource: [],
        insuranceType: [],
        insuranceCarrierName: [],
        race: [],
        methodOfPayment: [],
        treatmentSetting: [],
        physicianSpecialty: [],
        CoPayPrograms: [],
        employementStatus: [],
        gender: [],
        veteranAndHispanic: [],
        maritalStatus: [],
        applicantIs: [{
            key: 'Partner', value: 'Partner'
        }],
        emailType: [
            { key: "", value: "" },
            { key: "Home", value: "Home" },
            { key: "Work", value: "Work" },
            { key: "Other", value: "Other" },
        ],
        emailOwner: [
            { key: "", value: "" },
            { key: "Caregiver", value: "Caregiver" },
            { key: "Guardian", value: "Guardian" },
            { key: "Patient", value: "Patient" },
        ],
        phoneType: [
            { key: "Cell", value: "Cell" },
            { key: "Work", value: "Work" },
            { key: "Home", value: "Home" },
        ],
        contactSequence: [
            { key: "Primary", value: "Primary" },
        ],
        relationshipToPatient: [
            { key: "Grandparent", value: "Grandparent" },
            { key: "Other Family Member", value: "Other Family Member" },
            { key: "Parent", value: "Parent" },
            { key: "Other", value: "Other" },
        ],
        authRelationshipToPatient: [
            { key: "Friend", value: "Friend" },
            { key: "Family", value: "Family" },
            { key: "Caregiver", value: "Caregiver" },
        ],
        suffix: [
            { key: "I", value: "I" },
            { key: "II", value: "II" },
            { key: "III", value: "III" },
            { key: "IV", value: "IV" },
            { key: "Jr", value: "Jr" },
            { key: "Sr", value: "Sr" },
            { key: "V", value: "V" },
        ],
        houseHoldSize: [
            { key: "1", value: "1" },
            { key: "2", value: "2" },
            { key: "3", value: "3" },
            { key: "4", value: "4" },
            { key: "5", value: "5" },
            { key: "6", value: "6" },
            { key: "7", value: "7" },
            { key: "8", value: "8" },
            { key: "9", value: "9" },
            { key: "10", value: "10" },
        ],
        ePayment: [
            { key: "check", value: "check" },
            { key: "ePayment", value: "ePayment" },
        ], physicianAddressType: [
            { key: "Secondary", value: "Secondary" },
            { key: "Mailing", value: "Mailing" },
            { key: "Billing", value: "Billing" },
            { key: "Physical", value: "Physical" },
        ]
    },

}

const lookupSlice = createSlice({
    name: 'lookup',
    initialState,
    reducers: {
        resetLookup: (state) => {
            // toast.success("lookup reseted Successfully")

        },
        setProgramSpecificLookUp: (state, action) => {
            if (action.payload == 'CPR') {
                state.lookUp = state.lookUpCPR
            } else {
                state.lookUp = state.lookUpFAF
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLookUp.pending, (state, action) => {
            })
            .addCase(fetchLookUp.fulfilled, (state, action) => {
                let lookUp = action.payload.res;
                if (action.payload.Program == 'CPR') {
                    lookUp.length > 0 && lookUp.map((data) => {
                        if (data?.LookUpID == "State") {
                            // State
                            state.lookUpCPR.State.push({ key: data?.LookUpCode, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PLTP01") {
                            // Insurance Plan Type
                            state.lookUpCPR.insurancePlanType.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "FGP01") {
                            state.lookUpCPR.fundsList.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PREL01") {
                            //Preferred Language
                            state.lookUpCPR.preferredLanguage.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "CORRPREF01") {
                            //Preferred Method of contact
                            state.lookUpCPR.methodOfContact.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "CPRDIAg") {
                            //Patient Diagnosis list
                            state.lookUpCPR.patientDiagnosis.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "RELPro01") {
                            //Reffered Source
                            state.lookUpCPR.referredSource.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "INST01") {
                            //Insurance Type
                            state.lookUpCPR.insuranceType.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "HLTP01") {
                            //Insurance carrier name
                            state.lookUpCPR.insuranceCarrierName.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "RACE01") {
                            //Race
                            state.lookUpCPR.race.push({ key: data?.LookUpValue, value: data?.LookUpValue, isChecked: false })
                        } else if (data.LookUpID == "PREME01") {
                            //Method of Payment
                            state.lookUpCPR.methodOfPayment.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "TreatSet") {
                            //Treatment Setting
                            state.lookUpCPR.treatmentSetting.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PhySpe") {
                            //Physician Specialty
                            state.lookUpCPR.physicianSpecialty.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "CoPRo") {
                            //CoPay Programs
                            state.lookUpCPR.CoPayPrograms.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "EMP01") {
                            //Employement Status
                            state.lookUpCPR.employementStatus.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "GEN01") {
                            //gender
                            state.lookUpCPR.gender.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "YN01") {
                            //veterean / hispanic
                            state.lookUpCPR.veteranAndHispanic.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "MS01") {
                            //Marital Status
                            state.lookUpCPR.maritalStatus.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        }


                    })
                    // set default CPR data
                    state.lookUp = state.lookUpCPR
                } else {
                    lookUp.length > 0 && lookUp.map((data) => {
                        if (data?.LookUpID == "State") {
                            // State
                            state.lookUpFAF.State.push({ key: data?.LookUpCode, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PLTP01") {
                            // Insurance Plan Type
                            state.lookUpFAF.insurancePlanType.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "FGP01") {
                            state.lookUpFAF.fundsList.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PREL01") {
                            //Preferred Language
                            state.lookUpFAF.preferredLanguage.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "CORRPREF01") {
                            //Preferred Method of contact
                            state.lookUpFAF.methodOfContact.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "FAFDIAg") {
                            //Patient Diagnosis list
                            state.lookUpFAF.patientDiagnosis.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "RELPro01") {
                            //Reffered Source
                            state.lookUpFAF.referredSource.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "INST01") {
                            //Insurance Type
                            state.lookUpFAF.insuranceType.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "HLTP01") {
                            //Insurance carrier name
                            state.lookUpFAF.insuranceCarrierName.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "RACE01") {
                            //Race
                            state.lookUpFAF.race.push({ key: data?.LookUpValue, value: data?.LookUpValue, isChecked: false })
                        } else if (data.LookUpID == "PREME01") {
                            //Method of Payment
                            state.lookUpFAF.methodOfPayment.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "TreatSet") {
                            //Treatment Setting
                            state.lookUpFAF.treatmentSetting.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "PhySpe") {
                            //Physician Specialty
                            state.lookUpFAF.physicianSpecialty.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "CoPRo") {
                            //CoPay Programs
                            state.lookUpFAF.CoPayPrograms.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "EMP01") {
                            //Employement Status
                            state.lookUpFAF.employementStatus.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "GEN01") {
                            //gender
                            state.lookUpFAF.gender.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "YN01") {
                            //veterean / hispanic
                            state.lookUpFAF.veteranAndHispanic.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        } else if (data.LookUpID == "MS01") {
                            //Marital Status
                            state.lookUpFAF.maritalStatus.push({ key: data?.LookUpValue, value: data?.LookUpValue })
                        }


                    })
                }

            })
            .addCase(fetchLookUp.rejected, (state, action) => {
            })
    },
})

export const { resetLookup, setProgramSpecificLookUp } = lookupSlice.actions

export const lookUp = state => state.lookupSlice.lookUp
export default lookupSlice.reducer